import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CasinoComponent } from './casino/casino.component';
import { AuthGuard } from 'src/app/auth/guard';
import { CasinoDetailComponent } from './casino-detail/casino-detail.component';

const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "sports/:id",
        component: DashboardComponent,
      },
      {
        path: "casino/:id",
        component: CasinoComponent
      },
      {
        path: "casino-detail/:id/:cgameId",
        component: CasinoDetailComponent,
        canActivate: [AuthGuard],
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
